import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface DtToggleOption {
  value: string;
  label: string;
}

interface DtToggleProps {
  value: string;
  options: DtToggleOption[];
  onChange: (value: string) => void;
  disabled?: boolean;
  size?: "small" | "medium" | "large";
  sx?: object;
}

const sizeStyles = {
  small: {
    padding: "6px 16px",
    fontSize: "0.875rem",
  },
  medium: {
    padding: "8px 20px",
    fontSize: "0.9375rem",
  },
  large: {
    padding: "10px 28px",
    fontSize: "1rem",
  },
};

const DtToggleButton: React.FC<DtToggleProps> = ({
  value,
  options,
  onChange,
  disabled = false,
  size = "medium",
  sx = {},
}) => {
  const theme = useTheme();
  
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(_, val) => val && onChange(val)}
      size={size}
      disabled={disabled}
      sx={sx}
    >
      {options.map(option => (
        <ToggleButton
          key={option.value}
          value={option.value}
          sx={{
            ...sizeStyles[size],
             // Primary text color for default state
            color: theme.palette.primary.main,
            // Primary border
            borderColor: theme.palette.primary.main,
            // rounded-full
            borderRadius: 24,
            fontWeight: 500,
            '&.Mui-selected': {
              background: theme.palette.primary.main,    // Primary main background when selected
              color: theme.palette.primary.contrastText,
              borderColor: theme.palette.primary.main,
              '&:hover': {
                background: theme.palette.info.main,  // Cyan background on hover when selected
              },
            },
            '&:hover': {
              background: theme.palette.info.main,    // Cyan background on hover
              color: theme.palette.info.contrastText,
              borderColor: theme.palette.info.main,
            },
          }}
        >
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default DtToggleButton;